import Translate from '@wielink-application/translation/js/helpers/Translate.js';
export default Translate